@if (USER().authenticated && (showQuickflows || (showWorkflows && categories.length) || showAgentButton() || showNotifications)) {
    <button class="side-menu-toggler"
            [ngClass]="{'d-none': isMenuOpen}"
            ycnTooltip [tooltipTitle]="'Open Menu'" [tooltipPlacement]="'left'" [tooltipIgnoreViewport]="true"
            (click)="toggleMenu()">
        <svg ycnIcon [name]="'icon-close-arrow'"></svg>
    </button>
    <div class="side-menu order-2" [ngClass]="{'side-menu-opened': isMenuOpen}">
        <div class="side-menu-wrap">
            <ycn-background-jobs-progress-popover
               [jobsInProgress]="runningJobs()"/>
            <div class="side-menu-item side-menu-item-close">
                <button class="btn"
                        ycnTooltip [tooltipTitle]="'Close'" [tooltipPlacement]="'left'" [tooltipIgnoreViewport]="true"
                        (click)="toggleMenu()">
                    <svg ycnIcon [name]="'icon-close'"></svg>
                </button>
            </div>
            @if (showNotifications) {
                <div class="side-menu-item">
                    <button class="btn"
                            data-test-id="notifications-toggler"
                            [class.active]="isNotificationsActive()"
                            ycnTooltip [tooltipTitle]="'Notifications'" [tooltipPlacement]="'left'"
                            [tooltipIgnoreViewport]="true"
                            (click)="togglePanel('notifications')">
                        @if (isNotificationsActive()) {
                            <svg class="use-color" style="opacity: 0" ycnIcon [name]="'icon-notifications-color'"></svg>
                        } @else {
                            <svg class="use-current" ycnIcon [name]="'icon-notifications'"></svg>
                        }

                        @if (showJobCompletedCheck()) {
                            <div class="badge bg-gray-base-95 ng-scope">
                                <svg class="icon-check fill-current text-green" role="img" ycnIcon [name]="'icon-check'"></svg>
                            </div>
                        } @else if (unreadNotificationsCount() === 0 && hasRunningJobs()) {
                            <div class="badge bg-gray-base-95 text-white ng-scope">
                                <div class="circle-progress circle-progress-sm"></div>
                            </div>
                        } @else if (unreadNotificationsCount() > 0 && unreadNotificationsCount() < 20) {
                            <div class="badge bg-yc-blue-ada text-white ng-binding ng-scope">{{ unreadNotificationsCount() }}</div>
                        } @else if (unreadNotificationsCount() >= 20) {
                            <div class="badge bg-yc-blue-ada text-white ng-binding ng-scope">20+</div>
                        }
                    </button>
                </div>
            }
            @if (showAgentButton()) {
                <div class="side-menu-item">
                    <button class="btn"
                            data-test-id="ai-agent-toggler"
                            [class.active]="isAIAgentActive()"
                            ycnTooltip [tooltipTitle]="'Y - AI Agent'" [tooltipPlacement]="'left'"
                            [tooltipIgnoreViewport]="true"
                            (click)="handleAgentLink()">
                        @if (isAIAgentActive()) {
                            <svg class="use-color" style="opacity: 0" ycnIcon [name]="'icon-ai-agent-color'"></svg>
                        } @else {
                            <svg class="use-current" ycnIcon [name]="'icon-ai-agent'"></svg>
                        }
                    </button>
                </div>
            }
            @if (showQuickflows) {
                <div class="side-menu-item">
                    <button class="btn"
                            data-test-id="quickflows-toggler"
                            [class.active]="isQuickflowsActive()"
                            ycnTooltip [tooltipTitle]="'Quickflows'" [tooltipPlacement]="'left'"
                            [tooltipIgnoreViewport]="true"
                            (click)="togglePanel('quickflows')">
                        @if (isQuickflowsActive()) {
                            <svg class="use-color" style="opacity: 0" ycnIcon [name]="'icon-quickflows-color'"></svg>
                        } @else {
                            <svg class="use-current" ycnIcon [name]="'icon-quickflows'"></svg>
                        }
                    </button>
                </div>
            }
            @if (categories.length > 0 && showWorkflows) {
                <div class="side-menu-item">
                    <button class="btn"
                            data-test-id="workflows-toggler"
                            [class.active]="isWorkflowsActive()"
                            ycnTooltip [tooltipTitle]="'Workflows'" [tooltipPlacement]="'left'"
                            [tooltipIgnoreViewport]="true"
                            (click)="togglePanel('workflows')">
                        @if (isWorkflowsActive()) {
                            <svg class="use-color" style="opacity: 0" ycnIcon [name]="'icon-workflows-color'"></svg>
                        } @else {
                            <svg class="use-current" ycnIcon [name]="'icon-workflows'"></svg>
                        }
                    </button>
                </div>
            }
        </div>
    </div>
}
@if (prefsLoaded() && isSidePanelOpen()) {
        <div class="side-panel order-1 open"
             cdkDrag
             [cdkDragDisabled]="!isDetached()"
             [style.top.px]="isDetached() ? null : sidePanelTop"
             [style.width.px]="isDetached() ? detachedPanelWidth : null"
             [class.side-panel-ai]="isAIAgentActive()"
             [class.detached]="isDetached()"
        >
        <div class="side-panel-wrap" [style.height]="isDetached() ? '100%' : (sidePanelHeight || 'calc(-48px + 100dvh)')">
            <div class="side-panel-header bg-gray-base-90"
                 [class.bg-panel]="isAIAgentActive()"
                 [style.cursor]="isDetached() ? 'grab' : null"
                 cdkDragHandle>
                @if (type() === 'notifications') {
                    <div class="d-flex">
                        <div class="side-panel-title">Notifications</div>
                        @if (hasRunningJobs()) {
                            <div class="circle-progress ml-1 cursor-pointer"
                                ycnTooltip [tooltipTitle]="'In Progress Items'" [tooltipPlacement]="'right'" (click)="openBackgroundJobsProgressPopover()"></div>
                        }
                    </div>
                    <div class="d-flex ml-auto">
                        <a href="#"
                            (click)="deleteAllNotifications()"
                            [class.disabled]="notifications().length === 0"
                            [class.text-blue]="notifications().length > 0">
                                Dismiss All
                        </a>
                        <div class="divider-vertical mr-1 ml-1"></div>
                    </div>
                } @else if (type() === 'workflows') {
                    <div>
                        <div class="side-panel-title">Workflows</div>
                        @if (workflowsMenuComponent && workflowsMenuComponent.selectedSteps.length > 0) {
                            <a class="d-block text-gray-30 text-underline" href="javascript:void(0)"
                               (click)="clearSteps()">Back to Workflow Categories</a>
                        }
                    </div>
                } @else if (type() === 'quickflows') {
                    <div class="d-flex">
                        <div class="side-panel-title">Quickflows</div>
                        <a class="btn btn-circle btn-transparent2 btn-xs ml-1"
                           [href]="userPreferencesUrl" ycnTooltip [tooltipTitle]="'Quickflows Preferences'">
                            <svg ycnIcon [name]="'icon-gear'"></svg>
                        </a>
                    </div>
                } @else if (type() === 'ai_agent') {
                    <div class="d-flex">
                        <div class="side-panel-title">Y - AI Agent</div>
                    </div>
                }
                @if (isAIAgentActive()) {
                    <div class="d-flex align-items-center">
                        <a class="btn btn-circle btn-transparent2 btn-xs mr-1 flex-none" [href]="agentPageUrl()" ycnTooltip
                           tooltipTitle="Go To Full Page">
                            <svg ycnIcon name="icon-link-arrow"></svg>
                        </a>
                        <button class="btn btn-circle btn-transparent2 btn-xs mr-1 flex-none" ycnTooltip
                                [tooltipTitle]="isDetached() ? 'Attach Panel' : 'Detach Panel'"
                                (click)="toggleDetach()">
                            <svg ycnIcon [name]="isDetached() ? 'icon-reattach' : 'icon-unattach'"></svg>
                        </button>
                        <button class="btn btn-circle btn-transparent btn-xs flex-none side-panel-toggler" (click)="closeMenu()">
                            <svg ycnIcon [name]="'icon-close'"></svg>
                        </button>
                    </div>
                } @else {
                    <button class="btn btn-circle btn-transparent btn-xs side-panel-toggler" (click)="closeMenu()">
                        <svg ycnIcon [name]="'icon-close'"></svg>
                    </button>
                }
            </div>
            @if (type() === 'quickflows') {
                <ycn-quickflows-menu class="side-panel-content"
                                     [displaySecurityId]="displaySecurityId"
                                     [securityId]="securityId"
                                     [securityName]="securityName"
                                     [securityUrl]="securityUrl"
                ></ycn-quickflows-menu>
            } @else if (type() === 'workflows') {
                <ycn-guided-workflows-menu class="side-panel-content"
                                           [pagePath]="pagePath"
                                           [categories]="categories"
                                           [selectedSubcategoryId]="selectedSubcategoryId">
                </ycn-guided-workflows-menu>
            } @else if (type() === 'ai_agent') {
                <ycn-agent-side-panel
                    class="d-flex flex-column flex-auto overflow-auto"
                    [isDetached]="isDetached()"
                />
            } @else if (type() === 'notifications') {
                <ycn-notifications-side-menu class="side-panel-content pl-12 pr-12 pb-12 pt-12"
                    [(notifications)]="notifications"
                    [(topSectionPercentage)]="notificationsTopSectionPercentage"/>
            }
        </div>
</div>
}
<ycn-side-menu-toast-messages [containerClass]="'toast toast-below-header-right flex-column'"/>
